import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { promisify } from 'app/actions';
import { Row, Col } from 'react-bootstrap';
import { Button, Loader } from 'sa-ui';
import { compile, match } from 'path-to-regexp/dist';
import messages from './simulatedQuestionsMessages';
import {
  getQuestions,
  getQuestion,
  getEvaluation,
  approveEvaluation,
  reproveQuestion,
  approveQuestion,
} from './simulatedQuestionsActions';
import QuestionBadge from './QuestionBadge';
import SimulatedQuestionsCard from './SimulatedQuestionsCard';
import SimulatedQuestionLogHistory from './SimulatedQuestionLogHistory';
import './SimulatedQuestionsContainer.scss';
import ApproveEvaluationResultModal from './ApproveEvaluationResultModal';
import ReproveQuestionModal from './ReproveQuestionModal';
import ApproveQuestionModal from './ApproveQuestionModal';
import ReproveQuestionResultModal from './ReproveQuestionResultModal';
import ApproveQuestionResultModal from './ApproveQuestionResultModal';
import FinishValidationConfirmModal from './FinishValidationConfirmModal';
import { getEvaluations, getEvaluationSteps } from '../simulatedActions';

const questionsPatternUrl = '/simulated/:idEvaluation/questions/:idQuestion';

function SimulatedQuestionsContainer(props) {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [modals, setModals] = useState({});
  const [question, setQuestion] = useState();
  const [current, setCurrent] = useState(false);
  const { approved, repproved, withReason, intl } = props;

  async function fetch() {
    await Promise.all([
      setLoading(true),
      props.getEvaluations(),
      props.getEvaluationSteps({
        role: 'school',
      }),
      props.getEvaluation({
        idEvaluation: props.idEvaluation,
      }),
      props.getQuestions({
        idEvaluation: props.idEvaluation,
      }),
    ]);
    const { params } = match(questionsPatternUrl)(props.location.pathname);
    if (question || props.idQuestion) {
      await props.getQuestion({
        idEvaluation: props.idEvaluation,
        idQuestion: params.idQuestion || question.idQuestion,
      });
    }
    setLoading(false);
  }

  React.useEffect(() => {
    fetch();
  }, []);

  React.useEffect(() => {
    if (props.currentQuestion) {
      const url = compile(questionsPatternUrl)({
        idEvaluation: props.idEvaluation,
        idQuestion: props.currentQuestion.idQuestion,
      });
      setCurrent(true);
      props.history.replace(url);
    }

    return () => {
      setCurrent(false);
    };
  }, [props.currentQuestion]);

  async function selectQuestion(question) {
    setQuestion(question);
    setLoading(true);
    // const url = compile(questionsPatternUrl)({
    //   idEvaluation: props.idEvaluation,
    //   idQuestion: question.idQuestion,
    // });
    // props.history.replace(url);
    await props.getQuestion({ idEvaluation: props.idEvaluation, idQuestion: question.idQuestion });
    setLoading(false);
  }

  async function handleApproveEvaluation() {
    try {
      setLoading(true);
      await props.approveEvaluation({ idEvaluation: props.idEvaluation });
      await fetch();
    } finally {
      setLoading(false);
      setModals({ approveResult: true, finishValidation: false });
    }
  }

  function handleRequestApproveEvaluation() {
    setModals({ finishValidation: true });
  }

  async function handleReproveQuestion(question, comments) {
    try {
      setLoading(true);
      await props.reproveQuestion({
        idQuestion: question.idQuestion,
        idEvaluation: props.idEvaluation,
        comments,
      });
      await fetch();
    } finally {
      setLoading(false);
      setModals({ reproveQuestionResult: true, reproveQuestion: false });
    }
  }

  async function handleApproveQuestion(question) {
    try {
      setLoading(true);
      await props.approveQuestion({
        idQuestion: question.idQuestion,
        idEvaluation: props.idEvaluation,
      });
      await fetch();
      setModals({ approveQuestion: true });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  if (props.forbidden) {
    return <FormattedMessage {...messages.forbidden} />;
  }

  if (props.forbidden === undefined) {
    return null;
  }

  if (!props.evaluation || !props.evaluation.evaluation) return null;

  return (
    <div>
      <Loader show={loading} />
      <FinishValidationConfirmModal
        show={modals.finishValidation}
        onClose={() => setModals({ finishValidation: false })}
        onContinue={handleApproveEvaluation}
      />
      <ApproveEvaluationResultModal
        show={modals.approveResult}
        error={props.error.approve}
        evaluation={props.evaluation}
        onClose={() => setModals({ approveResult: false })}
      />
      <ReproveQuestionModal
        show={modals.reproveQuestion}
        question={props.currentQuestion}
        onClose={() => setModals({ reproveQuestion: false })}
        onContinue={(comments) => handleReproveQuestion(props.currentQuestion, comments)}
      />
      <ReproveQuestionResultModal
        error={props.error.reproveQuestion}
        show={modals.reproveQuestionResult}
        question={props.currentQuestion}
        onClose={() => setModals({ reproveQuestionResult: false })}
      />
      <ApproveQuestionModal
        show={modals.approveQuestion}
        question={props.currentQuestion}
        onClose={() => setModals({ approveQuestion: false })}
      />
      <button className="return simulated-questions--btn-link" onClick={() => props.history.go(-1)}>
        <i className="ti-arrow-left"> </i>
        {intl.formatMessage(messages.back)}
      </button>
      {/* <h5 className="title">{intl.formatMessage(messages.title)}</h5> */}
      {props.evaluation &&
        props.evaluation.evaluation &&
        props.evaluation.evaluation.levelSegment && (
          <h6 className="subtitle" style={{ marginTop: 15 }}>
            {props.evaluation.evaluation.levelSegment.map((l) => (
              <div>{l}</div>
            ))}
            {props.contract && <div>{props.contract.application}</div>}
          </h6>
        )}
      {props.evaluation &&
        props.evaluation.evaluation &&
        props.evaluation.evaluation.catalogings && (
          <div style={{ marginBottom: 25 }}>
            <h6 className="id mb-0">
              <div>
                {props.evaluation.evaluation.catalogings.map((c) => c.abbreviation).join(' | ')}
              </div>
              <div>ID: {props.evaluation.evaluation.idString}</div>
            </h6>
          </div>
        )}
      <div className="row mt-4">
        <div className="col-md-8">
          <h6 className="filter subtitle">
            <i className="ti-help-alt" />
            <FormattedMessage
              {...messages.showing}
              values={{
                quantity: props.currentQuestion ? props.currentQuestion.position : '',
                total: props.questionsData.total,
              }}
            />
          </h6>
          {props.currentQuestion && (
            <div>
              {props.currentQuestion.logHistory && props.currentQuestion.logHistory.length > 0 && (
                <SimulatedQuestionLogHistory data={props.currentQuestion.logHistory} />
              )}
              <SimulatedQuestionsCard
                {...props.currentQuestion}
                completed={props.completed}
                validateAccess={Number(props.evaluation.canValidateQuestions) === 1}
                onApprove={() => handleApproveQuestion(props.currentQuestion)}
                onReprove={() => setModals({ reproveQuestion: true })}
              />
            </div>
          )}
          <div>
            <small>ID #{props.currentQuestion && props.currentQuestion.idQuestion}</small>
          </div>
          {props.currentQuestion && props.currentQuestion.optionalQuestion && (
            <div>
              <SimulatedQuestionsCard
                {...props.currentQuestion.optionalQuestion}
                optional
                className="mt-4"
              />
              <div>
                <small>ID #{props.currentQuestion.optionalQuestion.idQuestion}</small>
              </div>
            </div>
          )}
        </div>
        <div className="col-md-4">
          <h6 className="filter subtitle">
            <i className="ti-check-box" />
            {intl.formatMessage(props.completed ? messages.questionsLabel : messages.approvation)}
          </h6>
          <div className="card card-adicionadas">
            <div className="card-questions">
              <div className="question-badges">
                {props.questionsData.questions &&
                  props.questionsData.questions.map((question) => (
                    <QuestionBadge
                      {...question}
                      onClick={() => selectQuestion(question)}
                      selected={
                        props.currentQuestion
                          ? props.currentQuestion.position === question.position
                          : false
                      }
                    />
                  ))}
              </div>
            </div>
            {!props.completed && Number(props.evaluation.canValidateQuestions) === 1 && (
              <div className="row mt-3">
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-block btn-lg"
                    onClick={handleRequestApproveEvaluation}
                  >
                    {intl.formatMessage(messages.finishValidation)}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps({ simulatedQuestions }, { match }) {
  return {
    ...match.params,
    ...simulatedQuestions,
  };
}

export default compose(
  injectIntl,
  withRouter,
  connect(
    mapStateToProps,
    promisify({
      getEvaluations,
      getEvaluationSteps,
      getQuestions,
      getQuestion,
      getEvaluation,
      approveEvaluation,
      reproveQuestion,
      approveQuestion,
    }),
  ),
)(SimulatedQuestionsContainer);
